module.exports = __webpack_public_path__ + "static/media/brainflix-tablet-hero.26334ad7.jpg";